import { render, staticRenderFns } from "./CustomerFormBank.vue?vue&type=template&id=f5b45970"
import script from "./CustomerFormBank.vue?vue&type=script&lang=js"
export * from "./CustomerFormBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports